<section class="get-started-page bg-white pb-5">
  <div class="get-started-page-title d-flex align-items-center">
    <span class="cx-back-indicator" aria-hidden="true">
      <app-icon name="chevron-left" class="cx-icon--md"></app-icon>
    </span>
    <img
      src="../../../assets/images/get-started-header-logo.png"
      class="mx-auto header-logo"
    />
  </div>
  <div class="col-12 text-center">
    <p class="font-24 fw-400">
      The platform where representatives and constituents connect
    </p>
  </div>
  <div class="container get-started-page-container">
    <div class="col-12 get-started-title">
      <p class="font-24 fw-600 text-center">
        Click below to get started in just a few steps:
      </p>
    </div>
    <div class="cta-card-section pb-5">
      <div class="row">
        <!-- Card 1 -->
        <div class="col-lg-6 mb-4 d-flex">
          <div class="cta-card w-100">
            <div class="cta-img cta-img-1"></div>

            <div class="cta-body">
              <p class="cta-title font-24 fw-600 pb-3 mb-3">
                For Elected Officials
              </p>
              <p class="cta-subtitle font-16 fw-400">
                Claim your official page or create one today to:
              </p>
              <ul class="cta-list">
                <li>Host virtual town halls</li>
                <li>Engage with your verified constituents directly</li>
              </ul>
              <button
                class="btn btn-outline-black get-started-btn cta-btn font-16 fw-600"
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
        <!-- Card 2 -->
        <div class="col-lg-6 mb-4 d-flex">
          <div class="cta-card w-100">
            <div class="cta-img cta-img-2"></div>
            <div class="cta-body">
              <h5 class="cta-title font-24 fw-600 pb-3 mb-3">
                For General Public
              </h5>
              <p class="cta-subtitle font-16 fw-400">
                Sign up in a few minutes to:
              </p>
              <ul class="cta-list">
                <li>Join conversations and polls</li>
                <li>Attend public and constituent-only virtual town halls</li>
                <li>Find and engage directly with your representatives</li>
              </ul>
              <button class="btn btn-outline-black cta-btn font-16 fw-600">
                Get Started
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
